var _defs, _path, _path2, _rect, _line, _line2, _line3, _path3, _line4, _line5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoiteAQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke: #47464b;\n      }\n\n      .cls-1, .cls-3 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.03px;\n      }\n\n      .cls-2 {\n        stroke-miterlimit: 10;\n        stroke-width: 1.73px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.12,48.08c1.81,1.54,2.71,3.66,2.71,6.35,0,.82-.07,1.58-.21,2.28-.67,3.72-2.32,6.47-4.94,8.26-2.62,1.79-5.88,2.68-9.78,2.68l-1.12,5.05h-4.2l1.28-8.4h1.54c3.54,0,6.39-.53,8.56-1.59,2.16-1.06,3.51-3.06,4.04-6,.11-.53.16-1.04.16-1.54,0-1.67-.53-2.98-1.59-3.93-1.06-.96-2.53-1.43-4.41-1.43-2.2,0-4.04.59-5.53,1.78-1.49,1.19-2.41,2.81-2.76,4.86h-4.57c.35-2.13,1.16-3.99,2.42-5.61,1.26-1.61,2.85-2.86,4.78-3.75,1.93-.89,4.03-1.33,6.3-1.33,3.08,0,5.53.77,7.33,2.31ZM73.75,82.86c-.51-.5-.77-1.15-.77-1.97,0-1.06.39-1.97,1.17-2.74.78-.76,1.7-1.14,2.76-1.14.81,0,1.47.25,1.97.74.5.5.74,1.15.74,1.97,0,1.06-.39,1.98-1.17,2.74-.78.76-1.68,1.14-2.71,1.14-.82,0-1.48-.25-1.99-.74Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.18,73.25V25.63c0-.88.71-1.59,1.59-1.59h48.61"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.62,
    y: 38.27,
    width: 50.2,
    height: 50.2,
    rx: 1.59,
    ry: 1.59
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 43.6,
    y1: 25.35,
    x2: 57.62,
    y2: 38.27
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 92.38,
    y1: 24.04,
    x2: 107.54,
    y2: 39.09
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 42.18,
    y1: 73.25,
    x2: 57.62,
    y2: 87.47
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.14,30.16v-13.47c0-2.02-1.48-3.66-3.31-3.66h-21.67c-1.83,0-3.31,1.64-3.31,3.66v13.09"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 57.74,
    y1: 30.16,
    x2: 90.38,
    y2: 30.16
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.49,
    y1: 50,
    x2: 45.49,
    y2: 63.37
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoiteAQuestion);
export default __webpack_public_path__ + "static/media/boite_a_question.53d92e038b5f90fcaded683fd2f45ac7.svg";
export { ForwardRef as ReactComponent };